import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/Breadcrumb/breadcrumb';
import { css } from '@patternfly/react-styles';
export var BreadcrumbHeading = function BreadcrumbHeading(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$to = _a.to,
      to = _a$to === void 0 ? null : _a$to,
      _a$target = _a.target,
      target = _a$target === void 0 ? null : _a$target,
      _a$component = _a.component,
      component = _a$component === void 0 ? 'a' : _a$component,
      props = __rest(_a, ["children", "className", "to", "target", "component"]);

  var Component = component;
  return React.createElement("li", Object.assign({}, props, {
    className: css(styles.breadcrumbItem, className)
  }), React.createElement("h1", {
    className: css(styles.breadcrumbHeading)
  }, to && React.createElement(Component, {
    href: to,
    target: target,
    className: css(styles.breadcrumbLink, styles.modifiers.current),
    "aria-current": "page"
  }, children), !to && React.createElement(React.Fragment, null, children)));
};